
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-link-curvature.html
riot.tag2('menu-item-link-curvature',
  '<ul class="floating-menu_list"> <li class="floating-menu_item {curvature === \'arc\' && \'floating-menu_item--active\'}" onclick="{setCurvature.bind(this, \'arc\')}"> <svg class="floating-menu_icon"> <use xlink:href="#line-arc-icon"></use> </svg> <span class="floating-menu_label">Curve</span> </li> <li class="floating-menu_item {curvature === \'elbow\' && \'floating-menu_item--active\'}" onclick="{setCurvature.bind(this, \'elbow\')}"> <svg class="floating-menu_icon"> <use xlink:href="#line-elbow-icon"></use> </svg> <span class="floating-menu_label">Elbow</span> </li> </ul>',
  '',
  'class=" floating-menu floating-menu--small {!isVisible && \'floating-menu--hidden\'} {opts.bottom && \'floating-menu--bottom\'} "', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _relationshipUi = require('lib/relationship-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

this.isVisible = false;

this.show = function (_ref) {
  var links = _ref.links;

  if (_this.isVisible) return;

  parent.hideSubMenus();

  Object.assign(_this, { links: links });

  _this.isVisible = true;
  _this.curvature = _relationshipUi.rui.getLineCurvature(links);

  _this.update();

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Open-Relationship-Type-Menu',
    label: 'Relationship'
  });
};

this.hide = function () {
  _this.isVisible = false;
  _this.update();
};

this.setCurvature = function (curvature, event) {
  event.stopPropagation();

  _this.curvature = curvature;
  _relationshipUi.rui.setLineCurvature(curvature, _this.links.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  }));
  parent.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-link-curvature')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-link-curvature.html
// module id = 786
// module chunks = 0